import { ContentBlock, GuideTypes, Image, Metadata } from "../models";
import { Entry } from "contentful";
import { findContent, parseIntoImage } from "../utils";
import { FieldMapping } from "../types";

export const createImage = (
  fieldMapping: FieldMapping<Image>,
  entries: Entry<ContentBlock & Metadata>[],
  guideType: GuideTypes,
): Image => ({
  image: parseIntoImage(
    findContent(entries, fieldMapping.image, guideType)?.fields.richContent
      .content[0].data,
  ),
});
